<template>
    <div class="box">
        <UserInfo style="margin-bottom:30px"/>
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane v-for="(item,i) in tabsData" :key="i" :name="item.name">
                <span slot="label" class="tabs" @mouseenter="showIconLight(i)" @mouseleave="showIconLight(-1)">
                    <svg v-if="item.name == activeName || iconIndex == i" class="icon" aria-hidden="true">
                        <use :xlink:href="item.iconLight"></use>
                    </svg>
                    <svg v-else class="icon" aria-hidden="true">
                        <use :xlink:href="item.icon"></use>
                    </svg>
                    {{item.name}}
                </span>
                <LearningData v-if="item.name == '學習數據'"/>
                <MyLesson v-if="item.name == '我的課程'"/>
                <MyTeching v-if="item.name == '我的教學'"/>
                <MyExercise v-if="item.name == '我的練習'"/>
                <MyExam v-if="item.name == '我的考試'"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import UserInfo from '@p/page/personal/components/userInfo.vue';
import LearningData from '@p/page/personal/components/learningData.vue';
import MyLesson from '@p/page/personal/components/myLesson.vue';
import MyTeching from '@p/page/personal/components/myTeching.vue';
import MyExercise from '@p/page/personal/components/myExercise.vue';
import MyExam from '@p/page/personal/components/myExam.vue';
import { setTimeout } from 'timers';
export default {
    components:{ UserInfo, LearningData, MyLesson, MyTeching, MyExercise, MyExam },
    data(){
        return{
            num:0,
            tob:3,
            tabs: [
                {name:'學習數據',icon:'#iconlearning',iconLight:'#iconlearningLight'},
                {name:'我的課程',icon:'#iconmyLesson',iconLight:'#iconmyLessonLight'},
                {name:'我的教學',icon:'#iconmyLearning',iconLight:'#iconmyLearningLight'},
                {name:'我的練習',icon:'#iconmyExercise',iconLight:'#iconmyExerciseLight'},
                {name:'我的考試',icon:'#iconmyExam',iconLight:'#iconmyExamLight'},
            ],
            activeName: "學習數據",
            iconIndex: -1
        }
    },
    created(){
        this.$store.commit('setFirstBreadcrumb',1)
        if (this.$route.query.tab) {
            this.activeName = this.$route.query.tab;
        }
    },
    computed:{
        tabsData(){
            if (!this.$store.state.home.userInfo.is_lecturer) {
                return this.tabs.filter((item, index) => {
                    return index != 2;
                })
            }else {
                return this.tabs;
            }
        }
    },
    methods:{
        showIconLight(i){
            this.iconIndex = i;
        },
        goAnchor(selector) {
            var anchor = document.querySelector(selector);
            document.documentElement.scrollTop = anchor.offsetTop - 90;
        },
        clickAnchor(selector,name){
            this.$router.replace({path:'/personal',query:{...this.$route.query,id:selector.substring(selector.length-1),title:name}})
            if (selector != '#anchor0') {
                let refSelect = selector.replace('#','');
                this.$refs[refSelect].noMore();
            }
        },
        countNum(){
            if(this.$store.state.home.userInfo.is_lecturer) this.tob=4;
            this.num+=1
            if (this.num==this.tob) {
                setTimeout(()=>{
                    this.goAnchor('#anchor'+this.$route.query.id)
                },500)
            }
        },
        tabClick(){
            this.$router.replace({path: '/personal', query: {...this.$route.query, tab: this.activeName}})
        }
    }
}
</script>
<style scoped>
.box{
    margin:20px 0;
}
.box >>> .el-card__header{
    color: #333;
    font-weight: bold;
    background-color: #F2F2F8;
    border-bottom: 1px solid #CECED9;
}
.box >>> .el-card__body{
    padding: 0;
}
.tabs{
    padding: 20px;
    font-size: 20px;
}
</style>